import React from 'react';
import { CandidateDocumentsViewRendererProps } from '../types';
import Desktop from './Desktop';

function ViewRenderer(props: CandidateDocumentsViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
